import { Modal } from "../layout/Modal";
import { Button } from "../ui/Button";
import { Card } from "../ui/Card";

type PartialSubmitConfirmationModalProps = {
	header?: string;
	message: string;
	submessage?: string;
	submitLabel?: string;
	onClose: () => void;
	onSubmit: () => void;
	trackingPrefix?: string;
};

export const PartialSubmitConfirmationModal = ({
	header,
	message,
	submessage,
	submitLabel = "Submit",
	onClose,
	onSubmit,
	trackingPrefix,
}: PartialSubmitConfirmationModalProps) => {
	return (
		<Modal onClickOutside={onClose}>
			<Card className="flex flex-col items-center w-[550px] max-w-[90vw] gap-[10px] overflow-hidden">
				{header && (
					<div className="w-full flex items-center space-x-[12px] justify-between bg-intent-warning-bg px-[18px] py-[10px]">
						<span className="text-[16px] font-[550]">{header}</span>
					</div>
				)}
				<div className="flex items-center flex-1 px-5 py-4 text-[16px] text-primary gap-[10px]">
					<div className="flex flex-col flex-1 gap-3 text-[18px]">
						<span>{message}</span>
						{submessage && <span className="text-[16px] text-secondary">{submessage}</span>}
					</div>
				</div>
				<div className="w-full flex justify-center gap-[10px] px-4 py-3 mb-[10px]">
					<Button
						color="primary"
						className="order-2 px-[20px] min-w-[120px]"
						onClick={onSubmit}
						trackingId={trackingPrefix ? `${trackingPrefix}-partial-submit` : undefined}
						filled
					>
						{submitLabel}
					</Button>
					<Button
						color="secondary"
						className="order-1 w-[120px]"
						onClick={onClose}
						trackingId={trackingPrefix ? `${trackingPrefix}-partial-back` : undefined}
					>
						Back
					</Button>
				</div>
			</Card>
		</Modal>
	);
};
